<template>
  <table class="data-table">
    <thead>
      <tr>
        <slot name="header" />
      </tr>
    </thead>
    <tbody>
      <slot />
    </tbody>
  </table>
</template>

<style scoped lang="scss">
.data-table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0 8px;
  table-layout: fixed;
}
.data-table :deep(th) {
  padding: 8px 24px;
  color: var(--primary);
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
  text-align: left;
}
.data-table :deep(td) {
  padding: 24px;
  overflow: hidden;
  border-top: 1px solid #eee;
  border-bottom: 1px solid #eee;
  background: var(--inverted);
  text-overflow: ellipsis;
  vertical-align: middle;
  white-space: nowrap;
}
.data-table :deep(td.data-table__loading) {
  border: none;
  background: transparent;
}
.data-table :deep(tbody tr:hover td.data-table__loading) {
  background: transparent;
}
.data-table :deep(tbody tr:hover td) {
  background: #fdfdfd;
}
.data-table :deep(td:first-child:not(.data-table__loading)) {
  border-left: 1px solid #eee;
  border-radius: 16px 0 0 16px;
}
.data-table :deep(td:last-child:not(.data-table__loading)) {
  border-right: 1px solid #eee;
  border-radius: 0 16px 16px 0;
}
.data-table :deep(td:first-child:last-child:not(.data-table__loading)) {
  border: 1px solid #eee;
  border-radius: 16px;
}
</style>
